// Visit https://api.openweathermap.org & then signup to get our API keys for free
module.exports = {
  key: "1f9c0e93df97d3b48201245ed4c82c2a",
  base: "https://api.openweathermap.org/data/2.5/",
};
